import { useCallback } from 'react';
import {
  GetPermanentAccessTokenHandler,
  getPermanentAccessTokenWithCookie,
  signOutAndClearCookies,
  useAuth,
} from '@ankr.com/auth';
import * as Sentry from '@sentry/react';

import { useAppDispatch } from 'store/useAppDispatch';
import { trackAuthenticationCompleted } from 'modules/analytics';
import { CONFIG } from 'modules/api/MultiService';

import { handlePermanentTokenError } from '../utils/handlePermanentTokenError';
import { AUTH_APP_ID, gateways } from '../const';
import { OAuthData } from '../../oauth/types';

export function useAuthInstance() {
  const dispatch = useAppDispatch();

  const getPermanentAccessToken = useCallback<GetPermanentAccessTokenHandler>(
    async params => {
      const provider = params.provider as OAuthData['provider'];

      try {
        const result = await getPermanentAccessTokenWithCookie(params);

        void trackAuthenticationCompleted({
          provider,
        });

        return result;
      } catch (error) {
        Sentry.withScope(scope => {
          scope.setExtra('provider', provider);
          Sentry.captureException(error);
        });

        handlePermanentTokenError({ dispatch, error });

        throw error;
      }
    },
    [dispatch],
  );

  return useAuth({
    appId: AUTH_APP_ID,
    getPermanentAccessToken,
    signOutFromAPI: signOutAndClearCookies,
    gateways,
    customAuthAPIBaseURL: `${CONFIG.accountUrl}api/v1`,
  });
}
